import LoadingVideo from './LoadingVideo';

export default LoadingVideo;
